export interface LicenseItemRenderDetails {
  status: string;
  borderColor: StatusColors;
  iconClass?: string;
}

export enum LicenseItemDetails {
  STATUS = 'status',
  BORDER_COLOR = 'borderColor',
  ICON_CLASS = 'iconClass',
}

export enum ProductStatusTexts {
  ACTIVE = 'Active',
  EXPIRED = 'Expired',
  TRIAL = 'Trial',
}

export enum StatusColors {
  DEFAULT = 'var(--chart-101-pressed-dividers)',
  ACTIVE = 'var(--green-layout-100-primary-green)',
  TRIAL = 'var(--orange-layout-050-warning)',
  EXPIRED = 'var(--red-layout-300-primary)',
}

export enum DisplayStyle {
  NONE = 'none',
  FLEX = 'flex',
}
